module.exports = __webpack_public_path__ + "static/media/banner.be2a4f33.png";